import * as React from "react";
import { Loader2, Check } from "lucide-react";

import { UploadProgressMap } from "@/interfaces";
import { Dialog, Progress } from "@/components/ui";
import { cn } from "@/lib/utils";

interface UploadProgressProps {
  open: boolean;
  header?: string;
  progressMap?: UploadProgressMap;
}

type Props = UploadProgressProps;

const UploadProgressModalFC: React.FC<Props> = ({ header = "Uploading Project Files", open, progressMap }) => {
  return (
    <Dialog open={open} onOpenChange={undefined} size="sm" disableEscapeDismissal={true}>
      <Dialog.Header>
        <Dialog.Title className="flex items-center gap-1.5 text-slate-800 text-sm font-semibold select-none">
          <Loader2 className="animate-spin size-4 text-indigo-600 shrink-0" />
          <span>{header}</span>
        </Dialog.Title>
      </Dialog.Header>

      <Dialog.Content className="p-5 flex flex-col gap-4 max-h-[50vh] overflow-y-auto">
        {progressMap && Object.entries(progressMap).length > 0 ? (
          <div className="flex flex-col gap-5 w-full">
            {Object.entries(progressMap).map(([key, { progress }]) => {
              const percentage = Math.trunc(progress * 100);
              const isComplete = percentage === 100;

              return (
                <div key={`progress-row-${key}`} className="flex flex-col gap-2 w-full">
                  <div className="flex flex-row justify-between items-center w-full select-none">
                    <span className="text-xs font-semibold text-slate-600 flex items-center gap-1.5">
                      {isComplete ? (
                        <Check className="size-3.5 text-emerald-500 shrink-0" />
                      ) : (
                        <div className="animate-spin rounded-full h-3 w-3 border border-indigo-500 border-t-transparent shrink-0" />
                      )}
                      <span>File {key}</span>
                    </span>
                    <span
                      className={cn(
                        "text-xs font-bold tabular-nums",
                        isComplete ? "text-emerald-600" : "text-slate-500"
                      )}
                    >
                      {percentage}%
                    </span>
                  </div>

                  <Progress value={percentage} className="w-full flex-col gap-0" />
                </div>
              );
            })}
          </div>
        ) : (
          <div className="text-center italic text-slate-400 py-4 text-xs">Preparing uploads...</div>
        )}
      </Dialog.Content>
    </Dialog>
  );
};

export const UploadProgressModal = UploadProgressModalFC;
